import { FileTextOutlined } from '@ant-design/icons';
import CardWithIcon from 'components/new-ui/base/card/CardWithIcon';
import BillingForm from './BillingForm';
import BillingView from './BillingView';

type Props = {
    isEditing: boolean;
};

const Billing = ({ isEditing }: Props) => {
    const content = isEditing ? <BillingForm /> : <BillingView />;

    return (
        <CardWithIcon
            bordered={false}
            title="Billing"
            gap="large"
            iconProps={{
                icon: <FileTextOutlined />,
                status: 'accent',
            }}
            children={<div style={{ marginTop: 24 }}>{content}</div>}
        />
    );
};

export default Billing;
